// extracted by mini-css-extract-plugin
export default {"blockedIssueIconWrapper":"item-state-module__blockedIssueIconWrapper--uIIW6","issueIcon":"item-state-module__issueIcon--ARzRg","blockedIcon":"item-state-module__blockedIcon--fUvAo"};